export function createTestId(label: string, name: string = label) {
  return name
}
